export const FORM_DISPENSARY = 'FORM_DISPENSARY'
export const FORM_DOCTOR = 'FORM_DOCTOR'
export const FORM_STAFF='FORM_STAFF'
export const FORM_DISPENSARY_STAFF = 'FORM_DISPENSARY_STAFF'
export const RESET_PASSWORD = 'RESET_PASSWORD'
